import logger from './utils/logger';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { BreadcrumbsProvider } from './context/BreadcrumbsContext';
// import { store } from "./redux/store";
import { setUser, setSessionChecked } from './redux/userSlice';
import './App.css';
import { CurrentUser, refreshToken } from './api/api'; // Import the API calls
import { RTLProvider } from './context/RTLContext';
import CookieConsentBanner from './components/CookieConsentBanner';

function InitializeUser() {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await CurrentUser();
        dispatch(setUser(response.user || response)); // Store user in Redux

        // Refresh token on app load to extend 7-day expiration
        try {
          await refreshToken();
          logger.info('Session token refreshed successfully.');
        } catch (refreshErr) {
          logger.error('Failed to refresh token:', refreshErr);
        }
      } catch (error) {
        logger.error('Error fetching user on reload:', error);
      } finally {
        dispatch(setSessionChecked(true)); // ✅ Always mark as checked so app can proceed
      }
    };

    fetchUser();
  }, [dispatch]);

  return null; // This component does not render anything
}

function App() {
  return (
    <RTLProvider>
      <BreadcrumbsProvider>
        <Router>
          <InitializeUser /> {/* Fetch user on app load */}
          <AppRoutes />
          <CookieConsentBanner />
        </Router>
      </BreadcrumbsProvider>
    </RTLProvider>
  );
}

export default App;
